<template>
  <div id="attachments">
    <!-- * Upload files -->
    <div class="title-attachments">
      <i class="fa fa-file tab-ico"/>{{ $t('upload_files') }}
    </div>
    <label class="drag-drop" v-cloak @drop.prevent="handleFileDrop($event)" @dragover.prevent for="upload-file" v-if="canEdit">
      <h2>{{ $t('drag_files_over') }}</h2>
    </label>
    <input id="upload-file" ref="upload-file" type="file" style="display:none" @change="handleFileDrop($event)" multiple v-if="canEdit" />
    <div v-if="files && files.length > 0">
      <div class="upload">
        <table>
          <tr v-for="file in files" :key="file.id">
            <td class="ellipsis">{{ file.file.name }}</td>
            <td><input type="text" v-model="file.description" :placeholder="$t('enter_description')" /></td>
            <td style="width:2.5em"><span @click="openDeleteModal(file)"><icon icoClass="title-ico" selected="delete" :title="$t('delete')" /></span></td>
          </tr>
        </table>
      </div>
      <div class="buttons">
        <button class="btn-blue is-small" @click="uploadToApi()">{{ $t('upload_files') }}</button>
      </div>
    </div>

    <load-screen :notFullScreen="true" v-show="loadingFiles"></load-screen>

    <!-- * Gallery view -->
    <div class="section-documents">
      <div v-if="objImages&&objImages.length>0" v-show="!loadingFiles" class="gallery-section">
        <div class="title center" style="font-size:1.2em;">{{ $t('gallery') }}</div>
        <div>
          <div class="gallery-scroll">
            <ul class="gallery">
              <li v-for="img in objImages" :key="img.id">
                <a :href="img.file" @click.prevent="openImageModal(img.file)" :title="img.name">
                  <img :src="img.file" :alt="img.name" :title="img.name">
                </a>
                <div class="delete-button fa fa-times" :title="$t('delete')" @click="openDeleteModal(img)" style="text-align: center;" />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- * Separator -->
      <div v-if="(objImages&&objImages.length>0)&&(objFiles&&objFiles.length>0)" v-show="!loadingFiles" style="border-left: 1px solid #ccc; margin: 0 1em;"></div>

      <!-- * Documents table -->
      <div v-if="objFiles&&objFiles.length>0" v-show="!loadingFiles" class="documents-section">
        <div class="title center" style="font-size:1.2em;">{{ $t('current_documents') }}</div>
        <div v-if="objFiles && objFiles.length > 0" class="documents">
          <table class="custom-table">
            <thead>
              <th>{{ $t('name') }}</th>
              <th>{{ $t('description') }}</th>
              <th />
            </thead>
            <tbody>
              <tr v-for="file in objFiles" :key="file.id">
                <td><a class="ellipsis" target="_blank" @click="downloadFile(file.id)" :title="file.name" style="cursor:pointer;">{{ file.name }}</a></td>
                <td>{{ file.description }}</td>
                <td style="width:2.5em"><span @click="openDeleteModal(file)"><icon icoClass='title-ico' selected='delete' :title="$t('delete')"/></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- * Buttons -->
    <div class="buttons" v-if="!selectFilesZip && !selectFilesMail">
      <button class="button btn-green" @click="selectFiles('zip')"><i class="fa fa-file-archive" />
        {{ $t('download_as_zip') }}</button>
      <button class="button btn-blue" @click="selectFiles('mail')"><i class="fa fa-envelope" />
        {{ $t('send_email') }}</button>
      <button class="button btn-black" @click="$emit('close')">{{ $t('close') }}</button>
    </div>
    <div class="buttons" v-else>
      <button v-if="selectFilesZip" class="button btn-green" @click="downloadZip(true)">{{ $t('download_images') }}</button>
      <button v-if="selectFilesZip" class="button btn-green" @click="downloadZip(false)">{{ $t('download_documents') }}</button>
      <button v-if="selectFilesZip" class="button btn-blue" @click="downloadZip()">{{ $t('download_all') }}</button>
      <button v-if="selectFilesMail" class="button btn-green" @click="openMailModal(true)">{{ $t('send_images') }}</button>
      <button v-if="selectFilesMail" class="button btn-green" @click="openMailModal(false)">{{ $t('send_documents') }}</button>
      <button v-if="selectFilesMail" class="button btn-blue" @click="openMailModal()">{{ $t('send_all') }}</button>
      <button class="button btn-black" @click="selectFiles()">{{ $t('cancel') }}</button>
    </div>

    <!-- * Modals -->
    <div v-if="showImageModal" class="modal-overlay" @click="closeImageModal">
      <div class="modal-content" @click.stop>
        <img :src="selectedImage" alt="Imagen Ampliada" style="max-width: 100%; max-height: 90%;" />
        <div class="modal-buttons">
          <a :href="selectedImage" download class="btn-blue is-small">{{ $t('download') }}</a>
          <button @click="closeImageModal" class="btn-black is-small">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
    <modal v-if="showMail">
      <div slot="body" style="padding:.5em 1.5em;">
        <div class="field">
          <label>{{ $t('enter_email') }} <a class="btn-blue btn-small">{{ $t('comma_separated') }}</a></label>
          <input type="email" v-model="recipient" style="width:100%; box-sizing: border-box;" multiple />
        </div>
        <div class="buttons">
          <button class="btn-green" @click="sendMail()">{{ $t('ok') }}</button>
          <button class="btn-black" @click="closeMailModal()">{{ $t('cancel') }}</button>
        </div>
      </div>
    </modal>
    <modal v-if="showDeleteModal">
      <div slot="body" class="delete-modal">
        {{ $t('delete_doc') }}
        <div class="buttons">
          <button class="btn-blue" @click="deleteFile(fileToDelete.id)">{{ $t('ok') }}</button>
          <button class="btn-black" @click="closeDeleteModal()">{{ $t('cancel') }}</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LoadScreen from './LoadScreen'
import Icon from './../svg/misc'
import Modal from './Modal'
export default {
  name: 'attachments',
  components: {
    LoadScreen,
    Modal,
    Icon
  },
  props: ['title', 'object', 'canEdit'],
  mounted () {
    const promises = []
    if (this.object && this.object.id) promises.push(this.getFiles(this.object))
    Promise.all(promises).then(() => { console.log('Files loaded') })
  },
  data () {
    return {
      selectFilesMail: false,
      showDeleteModal: false,
      showImageModal: false,
      selectFilesZip: false,
      loadingFiles: true,
      showMail: false,
      isImage: null,

      selectedImage: '',
      description: '',
      recipient: '',

      fileToDelete: {},
      objImages: [],
      objFiles: [],
      images: [],
      files: [],
      image: {},
      page: 1

      // selectedFiles: []
    }
  },
  computed: {
    ...mapState({
      count: state => state.document.count,
      pageSize: state => state.document.pageSize
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) pages.push(this.page - index)
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) pages.push(this.page + index)
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  watch: {
    object (newVal) {
      if (newVal) this.getFiles(newVal)
    }
  },
  methods: {
    ...mapActions({
      downloadAttachment: 'attachments/download',
      deleteAttachment: 'attachments/delete',
      saveAttachments: 'attachments/save',
      getAttachments: 'attachments/list',
      base64: 'attachments/base64',
      mail: 'attachments/mail',
      zip: 'attachments/zip'
    }),
    openImageModal (imageSrc) {
      this.selectedImage = imageSrc
      this.showImageModal = true
    },
    closeImageModal () {
      this.showImageModal = false
      this.selectedImage = ''
    },
    openMailModal (isImage = null) {
      this.isImage = isImage
      if (!this.validFiles()) return
      this.showMail = true
    },
    closeMailModal () {
      this.showMail = false
      this.recipient = ''
      this.isImage = null
    },
    openDeleteModal (file) {
      this.fileToDelete = file
      this.showDeleteModal = true
    },
    closeDeleteModal () {
      this.fileToDelete = {}
      this.showDeleteModal = false
    },
    selectFiles (type) {
      if (type === 'zip') this.selectFilesZip = !this.selectFilesZip
      else if (type === 'mail') this.selectFilesMail = !this.selectFilesMail
      else {
        this.selectFilesZip = this.selectFilesMail = false
        this.isImage = null
      }
    },
    downloadFile (fileId) {
      this.downloadAttachment(fileId)
    },
    deleteFile (fileId) {
      this.deleteAttachment(fileId).then(() => { this.getFiles(this.object) })
      this.closeDeleteModal()
    },
    downloadZip (isImage = null) {
      this.isImage = isImage
      if (!this.validFiles()) return

      this.zip({ id: this.object.id, basePath: this.getType(this.object), filters: { is_image: isImage } }).then(() => {
        this.$notify({ group: 'global', type: 'success', duration: 4000, title: 'Success', text: this.$t('zip_created') })
      }).finally(() => {
        this.selectFilesZip = false
        this.isImage = null
      })
    },
    sendMail () {
      if (!this.recipient) {
        this.notifyError('no_email')
        return
      }

      const mailArr = this.recipient.split(',').map(email => email.trim())
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const isValid = mailArr.every(email => emailRegex.test(email))

      if (!isValid) {
        this.notifyError('invalid_email')
        return
      }

      this.mail({ id: this.object.id, basePath: this.getType(this.object), mail: mailArr, is_image: this.isImage }).then(() => {
        this.$notify({ group: 'global', type: 'success', duration: 4000, title: 'Success', text: this.$t('mail_sent') })
      }).finally(() => {
        this.selectFilesMail = false
      })

      this.closeMailModal()
    },
    validFiles () {
      const hasImages = this.objImages.length > 0
      const hasFiles = this.objFiles.length > 0

      if (this.isImage === true && !hasImages) this.notifyError('no_images')
      else if (this.isImage === false && !hasFiles) this.notifyError('no_files')
      else if (this.isImage === null && !hasImages && !hasFiles) {
        this.notifyError('no_images')
        this.notifyError('no_files')
      } else return true

      return false
    },
    getType (object) {
      return object.type === 1 ? 'expedition' : 'reception'
    },
    notifyError (type) {
      this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t(type) })
    },
    getFiles (object) {
      this.getAttachments({ id: object.id, basePath: this.getType(this.object) }).then(response => {
        this.processFiles(response)
      })
    },
    processFiles (files) {
      this.loadingFiles = true
      this.objImages = []
      this.objFiles = []

      const processingPromises = files.map(file => {
        if (file.is_image) {
          return this.base64(file.id).then(res => {
            file.file = 'data:image/png;base64, ' + res.base64
            this.objImages.push(file)
          })
        } else {
          this.objFiles.push(file)
          return Promise.resolve()
        }
      })

      Promise.all(processingPromises).then(() => {
        this.loadingFiles = false
      })
    },
    handleFileDrop (f) {
      var files = f.target.files || f.dataTransfer.files
      if (!files.length) return

      for (var i = 0; i < files.length; i++) {
        var file = { file: files[i], description: '' }
        if (files[i].type.startsWith('image/')) file.is_image = true
        this.files.push(file)
      }

      const input = this.$refs['upload-file']
      input.type = 'text'
      input.type = 'file'
    },
    uploadToApi () {
      document.body.style.cursor = 'wait'

      const promises = this.files.map(file => {
        const formData = new FormData()
        formData.append('file', file.file)
        formData.append('description', file.description || file.file.name)
        formData.append('shipment', this.object.id)
        formData.append('company', this.object.company)
        formData.append('is_image', file.is_image ? file.is_image : false)

        return this.saveAttachments({ formData, id: this.object.id, basePath: this.getType(this.object) })
      })

      Promise.all(promises).then(results => {
        this.files = []
        this.$notify({group: 'global', duration: 4000, type: 'success', title: this.$t('success'), text: this.$t('saved')})
        results.forEach(file => {
          if (file.is_image) {
            this.base64(file.id).then((res) => {
              file.file = 'data:image/png;base64, ' + res.base64
              this.objImages.push(file)
            })
          } else this.objFiles.push(file)
        })
      }).finally(() => {
        document.body.style.cursor = 'default'
      }).finally(() => {
        document.body.style.cursor = 'default'
      })
    }
  }
}
</script>

<style scoped lang="scss">
#attachments {
  gap: 2rem;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
}
.title-attachments {
  font-family: 'Roboto', sans-serif;
  text-transform: uppercase;
  padding: 10px 5px;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5em;
  .center {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  i {
    margin-right: 0.5rem;
    color: #009D97;
  }
}
.drag-drop {
  border: 2px dashed #009D97;
  border-radius: 10px;
  padding: 1.5rem;
  text-align: center;
  color: #009D97;
  font-family: 'Open Sans', sans-serif;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #efffff;
  }
}
.upload {
  max-height:250px;
  overflow: auto;
  width:90%;
  margin: 1em auto;
  text-align:center;
  position: relative;
  table {
    width:100%;
    border-collapse: collapse;
    margin:0;
  }
}
#load-screen {
  background-color: transparent !important;
}
.section-documents {
  display: flex;
  gap: 1rem;
  max-height: 500px;
  overflow: hidden;
}
.gallery-section{
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.gallery-scroll {
  max-height: 100%;
  overflow-y: auto;
  flex: 1;
}
.documents-section {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.gallery::-webkit-scrollbar,
.documents::-webkit-scrollbar {
  width: 8px;
}

.gallery::-webkit-scrollbar-thumb,
.documents::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.gallery {
  max-height: 100%;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  li {
    list-style-type: none;
    position: relative;
    height: 10vh;
    margin: .5em;
    padding: .5em;
    box-shadow: 0 .5em 1em 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    padding: 1%;
    &:hover {
      box-shadow: 0 .8em 1.5em 0 rgba(0, 0, 0, 0.3);
      .delete-button {
        display: inline-block;
      }
    }
    input[type="checkbox"] {
      margin: 0;
    }
    a img {
      cursor: pointer;
      max-height: 100%;
      object-fit: contain;
      padding: 0;
      vertical-align: bottom;
    }
  }
  .delete-button {
    display: none;
    font-size: 1.3em;
    width: 1em;
    height: 1em;
    padding: 0.1em;
    z-index: 9999;
    background-size: cover;
    position: absolute;
    border-radius: 50%;
    background: rgb(230, 1, 13);
    color: white;
    cursor: pointer;
    top: -0.7em;
    right: -0.7em;
  }
}
.gallery-checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.documents {
  overflow-y: auto;
  max-height: 100%;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  flex: 1;
  table {
    width:100%;
    border-collapse: collapse;
    margin:0;
    height: 100%;
    border-spacing: 0 1rem;
    th, td {
      vertical-align: top;
    }
    th {
      text-align: left;
      font-weight: normal;
      color: #333;
    }
    td {
      padding: 1rem;
      background: white;
      border-radius: 8px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
      text-overflow: ellipsis;
      white-space: nowrap;
      .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 10em;
        display: inline-block;
      }
    }
    tr:hover td {
      background-color: #F4F7FA;
    }
  }
}
.delete-button {
  background-color: #E74C3C;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #C0392B;
  }
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    padding: 0 !important;
  }
}
.modal-buttons {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  .btn-blue, .btn-black {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-size: 1em;
    cursor: pointer;
    border-radius: 5px;
    text-decoration: none;
    text-align: center;
    min-height: 40px;
  }
  .btn-blue {
    padding: 0px 20px;
    &:hover {
      background-color: #5ab9b9;
    }
  }
  .btn-black {
    padding: 2px 20px;
    &:hover {
      background-color: #5e5e5e;
    }
  }
}
.buttons {
  display: flex;
  justify-content: center;
  margin-top: 1em;
  gap: 10px;
  .btn-green:hover {
    background-color: #e8ee8f;
  }
  .btn-blue:hover {
    background-color: #5ab9b9;
  }
  .btn-black:hover {
    background-color: #5e5e5e;
  }
}
@media (max-width: 768px) {
  .section-documents {
    flex-direction: column-reverse;
  }

  .drag-drop {
    padding: 1rem;
    h2 {
      font-size: 0.7em;
      letter-spacing: -0.5px;
    }
  }
  table {
    th:nth-child(2),
    td:nth-child(2) {
      display: none;
    }
  }

  .buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Attachments.vue